export default __webpack_public_path__ + "styles/UserAddOnPanel.7f637fc1e01355a85882d0a2edeee0e6.css";